import React from 'react';
import styled from 'styled-components';
import { Formik } from 'formik';
import Button from '../../app/common/components/Button';
import { TranslationHelpers } from '../../i18n/translationHelpers';
import { COLORS, FONT_FAMILY, MQS } from '../../app/common/constants/styles';
import { RenderChallenge } from '../../utils/challengerMain';
import OverlayHelper from '../../utils/overlayHelper';
import { PageId } from '../../config/constants/pageId.enum';

const Text = styled.div`
    margin: 30px 0;
    line-height: 1.5;

    & p {
        margin: 0;
    }
`;

const TextRedWrapper = styled.div``;
const TextRed = styled.p`
    margin: 0;
    line-height: 1.5;
    color: ${COLORS.redTitle};
    font-size: 1rem;
`;
const Actions = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 80px;
`;

const ChallengerWrapper = styled.div`
    margin-top: 50px;
    input.c-input {
        background-color: transparent;
        border: none;
        border-bottom: 1px solid;
        border-bottom-color: ${COLORS.grey3};
        border-radius: 0;
        color: ${COLORS.dark};
        display: block;
        ${FONT_FAMILY.multipleRegularCss}
        font-weight: 300;
        padding: 1px 1px 5px 1px;
        width: 100%;

        :placeholder-shown {
            padding-left: 0px;

            @media (min-width: ${MQS.mq1Min}) {
                font-size: 0.875rem;
            }

            @media (min-width: ${MQS.mq2Max}) {
                font-size: 1rem;
            }
        }

        @media (max-width: ${MQS.mq2Min}) {
            padding-left: 0;
        }

        :focus {
            outline: none;
            border-bottom: 2px solid ${COLORS.rakutenRed};
        }

        [disabled] {
            opacity: 1; // required for iOS safari;
            -webkit-text-fill-color: ${COLORS.grey3};
        }
    }
`;
interface IDeleteConfirmationProps {
    onAccept: (challengerPid: string) => void;
    onClose: () => void;
    deleting: boolean;
    apiError: any;
    challengerPid: string;
    challengerReadyCallback?: (ready: boolean) => void;
}

class DeleteConfirmation extends React.Component<IDeleteConfirmationProps> {
    constructor(props: IDeleteConfirmationProps) {
        super(props);
        const { challengerPid } = this.props;
        this.state = {
            isChallengeLoaded: !challengerPid,
        };
    }

    private renderChallenge(challengerPid: string) {
        return (
            <ChallengerWrapper>
                <RenderChallenge cpid={challengerPid} isReadyCallback={this.onChallengeReady} />
            </ChallengerWrapper>
        );
    }

    private onChallengeReady = (ready: boolean) => {
        if (this.props.challengerReadyCallback) {
            this.props.challengerReadyCallback(ready);
        }
        this.setState({ ...this.state, isChallengeLoaded: ready });
    };

    componentWillUnmount() {
        OverlayHelper.closeHelper(PageId.cancel_membership);
    }

    public render() {
        const { deleting, onAccept, onClose, challengerPid } = this.props;
        return (
            <div>
                <Text>
                    {TranslationHelpers.getFormattedMessage(
                        'rakservice.delete_confirmation.warning.top',
                    )}
                </Text>
                <TextRedWrapper>
                    <TextRed>
                        {TranslationHelpers.getFormattedMessage(
                            'rakservice.delete_confirmation.warning.red.line.one',
                        )}
                    </TextRed>
                    <TextRed>
                        {TranslationHelpers.getFormattedMessage(
                            'rakservice.delete_confirmation.warning.red.line.two',
                        )}
                    </TextRed>
                </TextRedWrapper>
                <Formik
                    initialValues={{
                        challengerPid,
                    }}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        setSubmitting(false);
                        resetForm();
                        onAccept(values.challengerPid);
                    }}
                >
                    {({ handleSubmit, handleReset }) => (
                        <form onSubmit={handleSubmit}>
                            {challengerPid && this.renderChallenge(challengerPid)}
                            <Actions>
                                <Button
                                    id="cancel"
                                    type="button"
                                    width="45%"
                                    primary={true}
                                    text={TranslationHelpers.getMessageDescriptor(
                                        'button.keepMembership',
                                    )}
                                    onClick={() => {
                                        handleReset();
                                        onClose();
                                    }}
                                    disabled={deleting}
                                    success={false}
                                    data-qa-id="cancel-action"
                                />

                                <Button
                                    id="confirm"
                                    type="submit"
                                    width="45%"
                                    disabled={deleting}
                                    success={false}
                                    loading={deleting}
                                    text={TranslationHelpers.getMessageDescriptor(
                                        'button.delete_account',
                                    )}
                                    data-qa-id="cancel-confirm"
                                    focusColor={COLORS.white}
                                />
                            </Actions>
                        </form>
                    )}
                </Formik>
            </div>
        );
    }
}

export default DeleteConfirmation;
